<template>
    <div class="_note">
        <!-- Content -->
        <div v-show="!loading">
            <textarea :placeholder="$t('read.tips')" class="notebook_input" v-model="note" style="resize: none" id="note"></textarea>
            <div class="btn-save-note">
                <button v-if='note != null && note != ""' @click="save()">{{ $t("read.save") }}</button>
                <button v-else class="disabled">{{ $t("read.save") }}</button>
            </div>
        </div>

        <!-- Loading -->
        <loading class="loading--lesson" :showLoading="loading" />
    </div>
</template>

<script>
    import loading from "@/components/loading/loading";

    export default {
        data() {
            return {
                note: null,
                firstNote: null,
                loading: true
            };
        },
        props: {
            course: {
                type: Object,
                default: {},
            }
        },
        components: {
            loading, 
        },
        created() {
            this.init();
        },
        destroyed () {
            if (this.note != this.firstNote && this.note != null && this.note != "") {
                this.$confirm(this.$t("js.confirmSaveNotes"), this.$t("js.hint"), {
                    confirmButtonText: this.$t("js.confirm"),
                    cancelButtonText: this.$t("js.cancel"),
                    type: 'warning'
                }).then(() => {
                    this.save();
                })
                .catch(() => {});
            }
        },
        methods: {
            init: async function () {
                // Get data note prev
                let data = await this.getData({materialId: this.course.activeID})

                // Set data
                this.note = data;
                this.firstNote = data;

                // Disabled loading
                this.loading = false;
            },

            // Get data onte
            getData: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getMaterialNote", params)
                    .then((response) => {
                        let note = response.data[0] ? response.data[0].noteContent : this.note;
                        resolve(note);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
                });
            },

            // Save note
            save: async function () {

                if (this.note == null || this.note == "") return;

                if (this.getLengthNote(this.note) > 100) {
                    this.$el_alert_type(window.vm.$i18n.t("js.wordMore"), "warning");
                    return;
                }

                // Check status note
                let status = await this.getStatus({materialId: this.course.activeID});

                if (status == 0) {
                    // Insert note
                    await this.insert({materialId: this.course.activeID, noteContent: this.note});
                } else {
                    // Update note
                    await this.update({materialId: this.course.activeID, noteContent: this.note});
                }

                this.firstNote = this.note;

                // Show msg success
                this.$el_alert_type(
                    window.vm.$i18n.t("js.saveSuccess"),
                    "success"
                );
            },
            
            getLengthNote: function (data) {
                let array = data.split("\n");
                let result = 0;
                array.forEach((obj) => {
                    let chinese = obj.match(/[\u4e00-\u9fa5。，？”“《》：！——-、]/g);
                    let chineselength = chinese ? chinese.length : 0;
                    let currentRows = Math.ceil((obj.length + chineselength) / 25);
                    result += currentRows;
                });
                return result;
            },

            // Get status
            getStatus: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getMaterialNoteExists", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Insert note
            insert: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/insertMaterialNote", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Update note
            update: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/updateMaterialNote", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            }
        }
    };
</script>

<style scoped>
    .disabled {
        background-color: gray !important;
        border: 2px solid gray !important;
        color: #fff !important;
    }
    .btn-save-note {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 60px;
        z-index: 2;
        border-top: 1px solid gray;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .btn-save-note button {
        width: 40%;
        height: 80%;
        border-radius: 5px;
        border: 2px solid #0071c5;
        background-color: #fff;
        color: #000;
        font-size: 14px;
        font-weight: 700;
        transition: ease 0.5s;
    }
    textarea {
        font-family: arial!important;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004) !important;
        text-rendering: optimizeLegibility !important;
        -webkit-font-smoothing: antialiased !important;
        box-sizing: border-box !important;
        border: 0 !important;
        border: none !important;
        padding: 5px !important;
        margin: 0 !important;
        resize: none !important;
        font-size: 14px !important;
        line-height: 1.3 !important;
        width: 100% !important;
        min-height: calc(100vh - 250px) !important;
        color: #161616 !important;
        transition: ease 0.4s !important;
        height: 44px !important;
    }
    .btn-save-note button:hover {
        background-color: #0071c5;
        color: #fff;
    }
    ._note {
        position: relative;
        height: 100%;
        width: 100%;
    }
    .loading {
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: rgb(38 50 56 / 0%);
        transform: translate(-50%, -50%);
    }
    /* Scroll */
    #note::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
        border-radius: 10px;
    }

    #note::-webkit-scrollbar {
        width: 5px;
        background-color: #ffffff;
        border-radius: 0 10px 10px 0;
    }

    #note::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    } 
</style>



// WEBPACK FOOTER //
// src/components/learn/note.vue